import { defaultInsuranceHubApiUrl } from "./partnership-store";

export interface HubApiImportResult {
  ok: boolean;
  invoiceId?: string;
  submissionId?: string;
  error?: string;
}

export async function postInvoiceImportToHubApi(token: string): Promise<HubApiImportResult> {
  const base = defaultInsuranceHubApiUrl();
  try {
    const res = await fetch(`${base}/invoices/import`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token }),
    });
    const body = (await res.json().catch(() => ({}))) as {
      invoiceId?: string;
      error?: string;
    };
    if (!res.ok) {
      return { ok: false, error: body.error ?? `Hub API — erreur ${res.status}` };
    }
    return { ok: true, invoiceId: body.invoiceId };
  } catch {
    return { ok: false, error: "Hub API inaccessible — démarrez itaas-insurance (port 3120)." };
  }
}

export async function postSubmissionImportToHubApi(token: string): Promise<HubApiImportResult> {
  const base = defaultInsuranceHubApiUrl();
  try {
    const res = await fetch(`${base}/submissions/import`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token }),
    });
    const body = (await res.json().catch(() => ({}))) as {
      submissionId?: string;
      error?: string;
    };
    if (!res.ok) {
      return { ok: false, error: body.error ?? `Hub API — erreur ${res.status}` };
    }
    return { ok: true, submissionId: body.submissionId };
  } catch {
    return { ok: false, error: "Hub API inaccessible — démarrez itaas-insurance (port 3120)." };
  }
}

export async function isHubApiReachable(): Promise<boolean> {
  const base = defaultInsuranceHubApiUrl().replace(/\/api\/v1\/?$/, "");
  try {
    const res = await fetch(`${base}/health`, { method: "GET" });
    return res.ok;
  } catch {
    return false;
  }
}

export async function revokePartnershipOnHubApi(partnershipId: string): Promise<boolean> {
  const base = defaultInsuranceHubApiUrl();
  try {
    const res = await fetch(`${base}/partnerships/${encodeURIComponent(partnershipId)}`, {
      method: "DELETE",
    });
    return res.ok;
  } catch {
    return false;
  }
}

export async function fetchSubmissionFromHubApi(
  submissionId: string,
): Promise<import("@itaas/insurance-contract").HubCoverageSubmission | null> {
  const base = defaultInsuranceHubApiUrl();
  try {
    const res = await fetch(`${base}/submissions/${encodeURIComponent(submissionId)}`);
    if (!res.ok) return null;
    const body = (await res.json()) as { submission?: import("@itaas/insurance-contract").HubCoverageSubmission };
    return body.submission ?? null;
  } catch {
    return null;
  }
}
